export default import.meta.ROLLDOWN_FILE_URL_Ei_aUnHjfvtGaZVPu0kL4g